import { render } from "./VerLlave.vue?vue&type=template&id=12e1b977"
import script from "./VerLlave.vue?vue&type=script&lang=js"
export * from "./VerLlave.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__